import React from "react";
import { Button } from "antd";
import styles from "./PriceFields.module.scss";

export type PriceField = {
  key: string;
  title: string;
  value: string | number;
  onChange: (value: string) => void;
  placeholder?: string;
};

export type PriceGroup = {
  key: string;
  title: string;
  fields: PriceField[];
};

interface PriceFieldsProps {
  groups: PriceGroup[];
  editing: boolean;
  /** No Edit button: the prices are only shown. */
  readOnly?: boolean;
  saving?: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

/**
 * A price grid on a phone: instead of one table row 14 columns wide, a
 * block per store (and the limits) with three fields a line, and the Edit,
 * Cancel and Save buttons under them, where the thumb is.
 */
const PriceFields: React.FC<PriceFieldsProps> = ({
  groups,
  editing,
  readOnly = false,
  saving = false,
  onEdit,
  onSave,
  onCancel,
}) => (
  <div className={styles.fields}>
    {groups.map((group) => (
      <section key={group.key} className={styles.group}>
        <h3 className={styles.groupTitle}>{group.title}</h3>
        <div className={styles.grid}>
          {group.fields.map((field) => (
            <label key={field.key} className={styles.field}>
              <span className={styles.label}>{field.title}</span>
              <input
                type="number"
                // The iPhone's keypad with a decimal point.
                inputMode="decimal"
                className={styles.input}
                value={field.value}
                placeholder={field.placeholder}
                onChange={(e) => field.onChange(e.target.value)}
                disabled={!editing || saving}
              />
            </label>
          ))}
        </div>
      </section>
    ))}
    {!readOnly && (
      <div className={styles.actions}>
        {editing ? (
          <>
            <Button onClick={onCancel} disabled={saving}>
              Cancel
            </Button>
            <Button type="primary" onClick={onSave} loading={saving}>
              Save
            </Button>
          </>
        ) : (
          <Button onClick={onEdit}>Edit prices</Button>
        )}
      </div>
    )}
  </div>
);

export default PriceFields;
